import { PropertiesStateType, PropertyType } from './types';

import { Pagination, PropertiesActionType } from 'enums';
import { PropertiesActionReturnType } from 'state/actions';

const initState: PropertiesStateType = {
  isLoading: false,
  properties: [],
  search: '',
  page: Pagination.START_PAGE,
  certainProperty: {} as PropertyType,
  uploadedCsv: [],
};

export const propertiesReducer = (
  // eslint-disable-next-line default-param-last
  state: PropertiesStateType = initState,
  action: PropertiesActionReturnType,
): PropertiesStateType => {
  switch (action.type) {
    case PropertiesActionType.SET_PROPERTIES:
      return { ...state, properties: action.properties };
    case PropertiesActionType.SET_PROPERTIES_AFTER_SCROLL:
      return { ...state, properties: [...state.properties, ...action.properties] };
    case PropertiesActionType.SEARCH_PROPERTIES:
      return { ...state, search: action.search };
    case PropertiesActionType.SET_PROPERTIES_PAGINATION:
      return { ...state, count: action.pagination.count, page: action.pagination.page };
    case PropertiesActionType.SET_CERTAIN_PROPERTY:
      return { ...state, certainProperty: action.property };
    case PropertiesActionType.SET_PROPERTIES_LOADING_STATUS:
      return { ...state, isLoading: action.isLoading };
    case PropertiesActionType.SET_UPLOADED_CSV:
      return { ...state, uploadedCsv: action.uploadedCsv };
    default:
      return state;
  }
};
